'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '0 0 1024 1024' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M512 224c-256 0-511.998 223.998-512 288v0c0.002 64.002 256 288 512 288s511.994-223.998 512-288v0c-0.006-64.002-256-288-512-288zM512 704c-106.042 0-192-85.96-192-192s85.958-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192zM384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z' })
    ));
};